import { render, staticRenderFns } from "./Istanbul.vue?vue&type=template&id=30358afe&"
import script from "./Istanbul.vue?vue&type=script&lang=js&"
export * from "./Istanbul.vue?vue&type=script&lang=js&"
import style0 from "./Istanbul.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Istanbul.vue"
export default component.exports